//import { filter } from "rxjs/operator/filter";

/* eslint-disable */
jQuery(document).ready(() => {

  jQuery('body').on('click', '.check-provider', function () {
    let check_data = jQuery(this).data();

    jQuery('.filter-sidebar__output').show();
    jQuery('#spn-output-'+check_data.term).attr( "data-term-reference", check_data.termReference ).show().children('label').html( check_data.termName );
    jQuery('#spn-output-'+check_data.term).attr( "data-term-id", jQuery(this).attr('data-term-id'));

    let field = check_data.term;

    jQuery('#fds-'+field).hide();

    if ( field == 'sub-service' ) {
      field = 'service';
    }

    let region    = jQuery('#spn-output-region').attr('data-term-reference');
    let service   = jQuery('#spn-output-service').attr('data-term-reference');
    let parent_id = jQuery('#spn-output-service').attr('data-term-id');

    if ( field == 'service' ) {
      service = check_data.termReference;
    }

    jQuery('.dinamic-service-type').remove();

    get_providers( service, region, 1, parent_id );
  });

  jQuery('body').on('click', '.output-item', function () {
    let check_data = jQuery(this).data();

    jQuery(this).attr('data-term-reference', '').hide();
    jQuery(this).attr('data-term-id', '');

    let region    = jQuery('#spn-output-region').attr('data-term-reference');
    let service   = jQuery('#spn-output-service').attr('data-term-reference');
    let parent_id = jQuery('#spn-output-service').attr('data-term-id');

    jQuery('#fds-'+check_data.term).show();
    jQuery('.dinamic-service-type').remove();

    // Verifica quantidade de elementos que estao em consulta, caso nao tenha, esconde o '.filter-sidebar__output'
    let elements = false;
    jQuery(".output-item").each(function(){
      if(jQuery(this).css("display")=="block"){
          elements = true;
      }
   });

   if ( ! elements ) {
    jQuery(".filter-sidebar__output").hide();
   }

    get_providers( service, region, 1 , parent_id );
  });

  jQuery('#load_more_provider').on('click', function () {
    let region    = jQuery('#spn-output-region').attr('data-term-reference');
    let service   = jQuery('#spn-output-service').attr('data-term-reference');

    const load_data  = jQuery(this).data();
    load_data.page++;

    jQuery(this).data('page', load_data.page);
    if (load_data.taxonomy == 'category') {
      service_type = get_provider_checked('.check-category', 'category-id');
    }
    get_providers(service, region, load_data.page, '', load_data.searchTerm, load_data.taxonomy);
  });

  if ( jQuery('#spn-output-service').length ) {
    if( jQuery('#spn-output-service').data().termId != '' ) {
      process_services_sub_category( jQuery('#spn-output-service').data().termId, true );
    }
  }

});

function get_providers(service, region, paged = 1, parent_id, search_term, taxonomy) {
  jQuery.ajax({
    type: 'POST',
    data: {
      action: 'get_providers', service, region, paged, parent_id, search_term, taxonomy,
    },
    dataType: 'json',
    url: window.wpGlobal_ajaxURL,
    beforeSend() {
      const top_position_element = '.secondary';
      jQuery('#loader').css('top', jQuery(top_position_element).position().top + jQuery(top_position_element).height()).show();
    },
    success(result) {
       jQuery('#loader').fadeOut(800);

      if ( parent_id && ! jQuery('#spn-output-sub-service').attr('data-term-id') ) {
        process_services_sub_category(parent_id);
      }

      if (paged == 1) {
        jQuery('.wrap-content__list').html('');
      }

      alternate_load_more(result.found_posts, result.posts_por_page);

      if (paged == result.max_num_pages) {
        jQuery('#load_more_provider').hide();
      }

      if (paged == 1) {
        toogle_not_found_msg(result.found_posts);
      }

      jQuery('.providers-result__output').html(result_singular_plural(result.found_posts, 'fornecedor', 'fornecedores' ));

      build_dinamic_services_type( result.services_filtered );
      build_dinamic_region( result.region_filtered );

      jQuery(result.providers).each((key, provider_data) => {
        jQuery('.wrap-content__list').append(build_provider_block(provider_data));
      });
    },
  });
}

function build_provider_block(provider_data) {
  let service_type = '';
  let spotlight = '';

  if (provider_data.service_type) {
    service_type = `<a href="${provider_data.service_type_link}">` +
    `<span class="area">${provider_data.service_type}</span>` +
    `</a>`;
  }

  if (provider_data.is_spotlight) {
    spotlight = `<div class="provider-spotlight" >Premium</div>`;
  }

  return `${'<div class="card-provider">' +
    '<figure class="card-provider__thumb">' +
    spotlight+
    '<a href="'}${provider_data.permalink}" title="Foto">` +
    `<img src="${provider_data.img_cropped}" alt="">` +
    '</a>' +
    '</figure>' +
    '<div class="card-provider__info">' +
    `<a href="${provider_data.permalink}" title="Foto">` +
    `<cite class="name">${provider_data.post_title}</cite><span class="location"><p>${provider_data.region}</p></span>` +
    `</a>${service_type}`+
    '</div>' +
    '</div>';
}

function build_dinamic_services_type( services_types ) {
  jQuery('#ul-provider-services-type').html('');
  jQuery.each( services_types, ( key, value ) => {
    jQuery('#ul-provider-services-type').append(
      `<li class="filter-sidebar__radio">`+
      `<input class="check-provider check-provider-service" type="radio" name="service" data-term="service" data-term-reference="${value.slug}" data-term-id="${value.term_id}" data-term-name="${value.name}" id="${value.slug}">`+
      `<label for="${value.slug}"> ${value.name} (${value.count})</label>`+
      `</li>`
    );
  });

  jQuery('#'+jQuery("#spn-output-service").attr('data-term-reference')).attr('checked', true);
}

function build_dinamic_region( region ) {
  jQuery('#ul-provider-region').html('');
  jQuery.each( region, ( key, value ) => {
    jQuery('#ul-provider-region').append(
      `<li class="filter-sidebar__radio">`+
      `<input class="check-provider check-provider-region provider-region-${value.term_id}" type="radio" name="location" data-term="region" data-term-reference="${value.term_id}" data-term-name="${value.name}" data-term-slug="${value.slug}" id="${value.slug}">`+
      `<label for="${value.slug}"> ${value.name} (${value.count})</label>`+
      `</li>`
    );
  });

  jQuery('.provider-region-'+jQuery("#spn-output-region").attr('data-term-reference')).attr('checked', true);
}

function toogle_not_found_msg(found_posts) {
  jQuery('.provider-results').hide();

  if (!found_posts) {
    jQuery('.provider-results').show();
  }
}

function alternate_load_more(result, post_per_page) {
  if (result > post_per_page) {
    jQuery('#load_more_provider').show();
  } else {
    jQuery('#load_more_provider').hide();
  }
}

function result_singular_plural( qtd_results , msg_singular, msg_plural ) {

  switch (qtd_results) {
    case 0:
       return 'Nenhum fornecedor';

    case '1':
       return qtd_results +' '+ msg_singular;

    default:
       return qtd_results +' '+ msg_plural;
  }
}

function reset_pagination() {
  jQuery('#load_more_provider').data('page', 1);
}

function build_childrens_services_group_provider(obj_childrens) {
  let children_block = '';
  let children_block_header = '';
  let children_block_footer = '';
  let children_content = '';

  jQuery.each(obj_childrens, (key, value) => {
    if (Object.keys(value.children).length) {
      children_block_header =
        `<fieldset class="dinamic-service-type" data-sub-service-id="${value.term_id}">` +
        `<span class="filter-sidebar__title">${value.name}</span>` +
        '<nav class="filter-sidebar__wrap">' +
        '<ul>';

      children_content = build_sub_servces_items(value.children);

      children_block_footer =
        '</ul>' +
        '</nav>' +
        '</fieldset>';
      children_block += children_block_header + children_content + children_block_footer;
    }
  });

  jQuery('.filter-sidebar').append(children_block);
}

function process_services_sub_category(parent_id, hide_loader = false ) {
  jQuery.ajax({
    type: 'POST',
    data: { action: 'get_provider_sub_filters', parent_id },
    dataType: 'json',
    url: window.wpGlobal_ajaxURL,
    beforeSend() {
      const top_position_element = '.secondary';

      if( ! hide_loader ) {
        jQuery('#loader').css('top', jQuery(top_position_element).position().top + jQuery(top_position_element).height()).show();
      }

    },
    success(services_response) {
      if (services_response[parent_id] && Object.keys(services_response[parent_id].children).length) {
        build_childrens_services_group_provider(services_response[parent_id].children);
      }
      jQuery('#loader').fadeOut(800);
    },
  });
}

function build_sub_servces_items(service_item) {
  let children_item = '';

  jQuery.each(service_item, (key, value) => {
  children_item +=
    `${'<li class="filter-sidebar__radio">' +
    '<input class="check-provider check-provider-service check-provider-service-sub-category" type="radio" name="sub-category-group" data-term="sub-service" data-term-reference="'}${value.slug}"  data-term-id="${value.term_id}" data-term-name="${value.name}" id="${value.slug}"  >` +
    `<label for="${value.slug}">${value.name}</label>` +
    '</li>';
  });
  return children_item;
}
